import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import action from "../../../../actions/index";
import PopularPlaces from "./PopularPlace";

const mapStateToProps = (state) => {
  return {
    popularPlacesState: state.popularPlaceReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getListPopularPlaces: (filters) => {
      dispatch(action.getListPopularPlaces(filters));
    },
    deletePopularPlace: (item) => {
      dispatch(action.deletePopularPlace(item));
    },
  };
};

export default withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(PopularPlaces)
);
